// !! This file exists twice !! //
// this file also is in the header!
// see the header twin file for an explanation

/** @typedef {import('@utahdts/utah-design-system-header').PopupPlacement} PopupPlacement */

/** @enum {PopupPlacement} */
export const popupPlacement = {
  AUTO: /** @type {PopupPlacement} */ ('auto'),
  AUTO_START: /** @type {PopupPlacement} */ ('auto-start'),
  AUTO_END: /** @type {PopupPlacement} */ ('auto-end'),
  BOTTOM: /** @type {PopupPlacement} */ ('bottom'),
  BOTTOM_START: /** @type {PopupPlacement} */ ('bottom-start'),
  BOTTOM_END: /** @type {PopupPlacement} */ ('bottom-end'),
  LEFT: /** @type {PopupPlacement} */ ('left'),
  LEFT_START: /** @type {PopupPlacement} */ ('left-start'),
  LEFT_END: /** @type {PopupPlacement} */ ('left-end'),
  RIGHT: /** @type {PopupPlacement} */ ('right'),
  RIGHT_START: /** @type {PopupPlacement} */ ('right-start'),
  RIGHT_END: /** @type {PopupPlacement} */ ('right-end'),
  TOP: /** @type {PopupPlacement} */ ('top'),
  TOP_START: /** @type {PopupPlacement} */ ('top-start'),
  TOP_END: /** @type {PopupPlacement} */ ('top-end'),
};
